import { create } from 'zustand'

type DesktopUtilityWindowId = 'wallpaper' | 'preferences' | 'log-viewer'

type DesktopUtilityWindowsStore = {
  activeWindow: DesktopUtilityWindowId | null
  openWindow: (windowId: DesktopUtilityWindowId) => void
  closeWindow: () => void
  isWindowOpen: (windowId: DesktopUtilityWindowId) => boolean
}

export const useDesktopUtilityWindowsStore =
  create<DesktopUtilityWindowsStore>()((set, get) => ({
    activeWindow: null,
    openWindow: windowId => set({ activeWindow: windowId }),
    closeWindow: () => set({ activeWindow: null }),
    isWindowOpen: windowId => get().activeWindow === windowId
  }))
